import { Box } from '@mui/material';
import { Button, Select } from 'antd';
import React, { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '@/redux/store';

import { GroupContext } from '../PileCtxProvider';

const FunctionRows = () => {
  const { sortBy, setSortBy } = useContext(GroupContext);

  const userGroup = useSelector((state: RootState) => state.user.userGroup);

  const chargingPilePageAuth = useMemo(
    () =>
      userGroup?.userRouter?.find(
        (item: { name: string }) => item.name === '汽車充電樁'
      ),
    [userGroup?.userRouter]
  );

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '10px',
        alignItems: 'center',
        flexWrap: 'wrap',
      }}
    >
      {chargingPilePageAuth?.children.find(
        (item: { name: string }) => item.name === '充電樁歷史紀錄'
      ) && (
        <Button
          onClick={() => {
            location.hash = 'ezpro/energy/chargingPileExpenseList';
          }}
        >
          下載充電樁歷史紀錄
        </Button>
      )}
      <Select
        style={{ width: '150px' }}
        defaultValue={sortBy}
        onChange={(value) => {
          setSortBy(value);
        }}
        options={[
          { label: '戶號', value: 'householdNumber' },
          { label: '車位號', value: 'parkingNumber' },
          { label: '充電樁號', value: 'chargingPileID' },
        ]}
      />
    </Box>
  );
};

export default FunctionRows;
